<script>
  export default {
    name: "SelectInput",
    props: {
      value: [String, Number],
      options: { type: Array, default: () => [] },
      disabled: { type: Boolean, default: false },
    },
  };
</script>

<template>
  <select class="select" :value="value" :disabled="disabled" @input="$emit('input', $event.target.value)">
    <option v-for="opt in options" :key="opt.value" :value="opt.value">
      {{ opt.label }}
    </option>
  </select>
</template>

<style lang="scss" scoped>
  .select {
    padding: 6px 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    font-family: $newFont_regular;
    color: #3d3d3d;

    &:disabled {
      background: #f5f5f5;
    }

    &:focus {
      outline: none;
      border-color: #3d3d3d;
    }
  }
</style>
